import React, { createContext, useContext, useState } from 'react'
import { axiosSanctumInstance } from '~/src/config/config_axios'
import { initAuthState } from '~/src/recoil'
import { TAuthAtomState } from '~/src/recoil/atoms/authAtom'
import { authEvent } from '../events/AuthEvent'

type Context = ReturnType<typeof useProvideAuth>
type LoginParams = {
  username: string
  password: string
}

const authContext = createContext({} as Context)

export const ProvideAuth: React.FC = ({ children }) => {
  const auth = useProvideAuth()
  return <authContext.Provider value={auth}>{children}</authContext.Provider>
}

export const useAuth = () => useContext(authContext)

// Provider hook that creates auth object and handles state
const useProvideAuth = () => {
  const [user, setUser] = useState<TAuthAtomState>(initAuthState)
  // TODO: APIが401を返したときの対応
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(
    localStorage.getItem('isAuthenticated') === 'true'
  )
  const [isAuthenticatedError, setIsAuthenticatedError] = useState<boolean>(false)

  /**
   * login
   * @param params {LoginParams}
   */
  const login = async (params: LoginParams) => {
    await axiosSanctumInstance.get('/sanctum/csrf-cookie', { withCredentials: true })
    try {
      await axiosSanctumInstance.post('/api/login', params, {
        withCredentials: true,
      })
      localStorage.setItem('isAuthenticated', 'true')
      setIsAuthenticated(true)
    } catch (error) {
      setIsAuthenticatedError(true)
      throw error
    }
  }
  /**
   * logout
   */
  const logout = async () => {
    setUser(initAuthState)
    setIsAuthenticated(false)
    localStorage.removeItem('isAuthenticated')
  }
  authEvent.on('unauthenticated', () => logout())

  // Return the user object and auth methods
  return {
    user,
    isAuthenticated,
    isAuthenticatedError,
    login,
    logout,
  }
}
